import axios from 'axios';
import api from '@src/api';

export const state = {
  autoCompleteLists: null,
  nutritionDiets: null,
  nutritionHealths: null,
  nutritionTags: null,
};

export const getters = {};

export const mutations = {
  setAutoCompleteLists(state, value) {
    state.autoCompleteLists = value;
  },
  setNutritionDiets(state, value) {
    state.nutritionDiets = value;
  },
  setNutritionHealths(state, value) {
    state.nutritionHealths = value;
  },
  setNutritionTags(state, value) {
    state.nutritionTags = value;
  },
};

export const actions = {
  init({ state, dispatch, rootState }) {
    if (rootState.auth && rootState.auth.currentUser) {
      dispatch('getNutritionDiets');
      dispatch('getNutritionHealths');
      dispatch('getNutritionTags');
      dispatch('getAutocompleteLists');
    }
  },
  getNutritionDiets(ctx) {
    const url = api.URL_GET_NUTRITION_DIET_OPTS;

    return axios
      .get(url)
      .then((res) => {
        ctx.commit('setNutritionDiets', res.data);
        return res.data;
      })
      .catch((err) => {
        console.warn(err);
      });
  },

  getNutritionHealths(ctx) {
    const url = api.URL_GET_NUTRITION_HEALTH_OPTS;

    return axios
      .get(url)
      .then((res) => {
        ctx.commit('setNutritionHealths', res.data);
        return res.data;
      })
      .catch((err) => {
        console.warn(err);
      });
  },

  getNutritionTags(ctx) {
    const url = api.URL_GET_NUTRITION_TAGS;

    return axios
      .get(url)
      .then((res) => {
        ctx.commit('setNutritionTags', res.data);
        return res.data;
      })
      .catch((err) => {
        console.warn(err);
      });
  },

  getAutocompleteLists(ctx) {
    const url = api.URL_GET_AUTOCOMPLETE_LISTS;

    return axios
      .get(url)
      .then((res) => {
        ctx.commit('setAutoCompleteLists', res.data);
        return res.data;
      })
      .catch((err) => {
        console.warn(err);
      });
  },
};
